export const apiUrl = process.env.REACT_APP_API_URL;
console.log("API URL: ", apiUrl)
console.log("process.env : ", process.env)